<header id="site_header" class="site-header">
    <div class="header-top">
        <div class="container">
            <div class="top-hader-main-box white-text">
                <a href="https://maps.app.goo.gl/BWyoU2MVUnQa7JEf7" title="Al Sajaa industrial area, Near Cement factory, Sharjah, UAE" target="_blank" class="top-bar-link">
                    <img src="assets/img/map-pin-transparent.svg" class="me-2" width="18" height="18" alt="Phone Icon">
                    <span>Al Sajaa industrial area, Near Cement factory, Sharjah, UAE</span>
                </a>
                <ul class="header-social">
                    <li>
                        <a href="mailto:goldendropoilind@gmail.com" title="Mail on goldendropoilind@gmail.com">
                            <img src="assets/img/mail-icon.svg" width="18" height="13" alt="Mail Icon">
                            <span>goldendropoilind&#64;gmail.com</span>
                        </a>
                    </li>
                    <li>
                        <a href="tel:+919879874987" title="Call on +971 58 129 2000">
                            <img src="assets/img/phone-icon.svg" width="18" height="18" alt="Phone Icon">
                            <span>+971 58 129 2000</span>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
    <div class="heder-main">
        <div class="container">
            <div class="row">
                <div class="col-lg-2 align-self-center">
                    <div class="site-branding">
                        <a routerLink="/" title="goldol">
                            <img src="assets/img/goldol-logo.png" class="goldol-header-logo" alt="goldol Logo">
                        </a>
                    </div>
                </div>
                <div class="col-lg-10 align-self-center">
                    <div class="header-menu">
                        <nav class="main-navigation">
                            <button class="menu-toggle for-mob-flex">
                                <span></span>
                                <span></span>
                                <span></span>
                            </button>
                            <div class="header-mobile-menu">
                                <ul class="main-menu">
                                    <li [class.active-menu]="isActive('/')">
                                        <a routerLink="/" title="About Us">Home</a>
                                    </li>
                                    <li [class.active-menu]="isActive('/about')">
                                        <a routerLink="/about" title="About Us">About Us</a>
                                    </li>
                                    <li [class.active-menu]="isActive('/products')">
                                        <a routerLink="/products" title="Products">Products</a>
                                    </li>
                                    <li [class.active-menu]="isActive('/careers')">
                                        <a routerLink="/careers" title="Careers">Careers</a>
                                    </li>
                                    <li [class.active-menu]="isActive('/faq')">
                                        <a routerLink="/faq" title="FAQ">Faq</a>
                                    </li>
                                    <li [class.active-menu]="isActive('/contact')">
                                        <a routerLink="/contact" title="Contact Us">Contact Us</a>
                                    </li>
                                </ul>
                                <div class="header-cta">
                                    <a href="assets/catalogue/catalogue.pdf" target="_blank" class="sec-btn" title="Catalogue">CATALOGUE</a>
                                </div>
                                <!-- <div id="google_translate_element"></div> -->
                            </div>
                        </nav>
                        <div class="black-shadow"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</header>